import React from 'react';
import TermsTemplate from './TermsTemplate';

export default function LocationTerms() {
  const content = `
    <h2>제1조 (위치정보 수집 목적)</h2>
    <p>여기에 location_terms.txt 내용을 복사 붙여넣기 해주세요.</p>

    <h2>제2조 (위치정보 수집 방법)</h2>
    <p>위치정보는 다음과 같은 방법으로 수집됩니다.</p>
    <ul>
      <li>GPS를 통한 위치정보 수집</li>
      <li>Wi-Fi 기반 위치정보 수집</li>
      <li>기지국 기반 위치정보 수집</li>
    </ul>

    <h2>제3조 (위치정보의 이용 및 제공)</h2>
    <p>위치정보 이용...</p>

    <h2>제4조 (위치정보 보호)</h2>
    <p>위치정보 보호...</p>
  `;

  return (
    <TermsTemplate
      title="위치기반서비스 이용약관"
      content={content}
      lastUpdated="2025년 1월 1일"
    />
  );
}
